import React from 'react'
import Modal from '@/components/NotificationModal'
import {Stack} from '@mui/material'
import {colors, colorsButtons} from '@/constants'
import HoverButton from '@/components/UI/button/HoverButton'
import useAcceptModal from '@/hooks/modalAccept'
import {useTranslation} from 'react-i18next'

interface AcceptModalInterface {
  handleAgree: () => void
  confirmText?: string
  cancelText?: string
  width?: string
  children?: any
  zIndex?: number
  handleCancel?: () => void
  withoutCancel?: boolean
  padding?: string
  firework?: boolean
}

const Index = ({
  children,
  confirmText,
  cancelText,
  handleAgree,
  handleCancel,
  width,
  zIndex,
  withoutCancel = false,
  padding = '80px 120px',
  firework = false,
}: AcceptModalInterface) => {
  const {t} = useTranslation()
  const {hideAcceptModal} = useAcceptModal()

  return (
    <Modal
      zIndex={zIndex}
      firework={firework}
      styles={{
        background: '#0F0A00F2',
        maxWidth: '930px',
        width: width ? width : '100%',
      }}
      stylesContainer={{
        border: `1px solid ${colors.lightBrown}`,
        borderRadius: '20px',
      }}>
      <Stack
        padding={padding}
        height="100%"
        justifyContent="space-between"
        boxSizing="border-box"
        alignItems="center"
        gap="20px">
        {children}
        <Stack
          width="400px"
          gap="20px"
          marginTop="20px"
          alignItems="center"
          justifyContent="center">
          <HoverButton
            onClick={(e: Event) => {
              handleAgree()
              hideAcceptModal()
              e.stopPropagation()
            }}
            fontSize="20px"
            fontWeight="400"
            height="50px"
            textColor={colors.white}
            boxShadowHover="0px 0px 10px 0px #FFF17266 inset"
            width="inherit"
            padding="10px 20px">
            {confirmText ? t(confirmText) : t('1210')}
          </HoverButton>
          {!withoutCancel && (
            <HoverButton
              onClick={(e: Event) => {
                hideAcceptModal()
                e.stopPropagation()
                if (handleCancel) {
                  handleCancel()
                }
              }}
              background={colorsButtons.decline}
              fontSize="20px"
              fontWeight="400"
              height="50px"
              textColor={colors.white}
              boxShadowHover="0px 0px 10px 0px #FFF17266 inset"
              width="inherit"
              padding="10px 20px">
              {cancelText ? t(cancelText) : t('1203')}
            </HoverButton>
          )}
        </Stack>
      </Stack>
    </Modal>
  )
}

export default Index
